import { Injectable } from '@angular/core';
import { EnrichResource } from './resource.service';
import { Role } from './models/role.model';
import { RoleFactory } from './factories/role.factory';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RoleResource extends EnrichResource<Role> {
  protected resource: string = 'roles';

  constructor(
    protected httpClient: HttpClient,
    protected roleFactory: RoleFactory,
  ) {
    super(httpClient, roleFactory);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/role.resource.ts